import ModuleEntitiesStep from '../../components/module_entities_step'

class InviteToModules extends ModuleEntitiesStep {
  constructor() {
    super()
    this.jQuery = window.$
    this.select_all_modules = document.querySelector('#select_all_modules')
    this.bindEvents()
  }

  bindEvents() {
    const self = this

    const userEmail = self.jQuery('#invite_to_modules_form_email').val()

    self.headerMessage('invite_to_modules', userEmail)

    document.querySelectorAll('.module-entities-table input[type=checkbox]:checked')
      .forEach((element) => {
        const el = element
        el.disabled = true
      })

    this.select_all_modules.addEventListener('change', () => {
      document.querySelectorAll('.module-entities-table input[type=checkbox]:not(:disabled)')
        .forEach((element) => {
          const el = element

          el.checked = this.select_all_modules.checked
        })
    })
  }
}

export default InviteToModules
